import { render } from "./ReqMain.vue?vue&type=template&id=010f59fe&scoped=true"
import script from "./ReqMain.vue?vue&type=script&lang=js"
export * from "./ReqMain.vue?vue&type=script&lang=js"

import "./ReqMain.vue?vue&type=style&index=0&id=010f59fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010f59fe"]])

export default __exports__